var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgjsline1438(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 2,
    viewBox: "0 0 426 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.588837 1.44572H425.664",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgjsline1438);
export default __webpack_public_path__ + "static/media/svgjsline1438.bd277078472f5f0216d53d4755f301a7.svg";
export { ForwardRef as ReactComponent };